import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

} from '@mui/material';
import Grid from "@mui/material/Grid"
import { useFormik } from 'formik';

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { useTranslation, getLanguage } from 'react-multi-lang';
import { useNavigate, useParams } from 'react-router-dom';
import  { bill } from '../../services/api/api';
import {
  InputField,
  NumberField,

  Textarea,
} from '../../components/FormElements/FormElements';
import {
  MySuccessMark,

  ErrorMark,
  EllipsisLoader,
} from '../../components/Loader/Loader';

import { MyRadioGroup } from '../../components/radio-group/radio-group';

import { havePermission } from '../../services/hoc/permissions';
import { useCookies } from 'react-cookie';
import { convertDate } from '../../services/convertDate';
import { NumberToString } from '../../services/to_wrtten_number';
import GreenButton from '../../components/buttons/green-button';

import { IconButton } from '../../components/icon-button';
import {
  Cancel,
  Launch,
  Print,
  PrintTwoTone,
  Save,
} from '@mui/icons-material';
import { PrintBill } from '../../components/print/print_bill';
import WhiteButton from '../../components/buttons/white-button';
import { useNotification } from '../../services/usenotification';
import Title from '../../components/Title/Title';
import { useAPI } from '../../services/hoc/useAPI';
import { BillValidation } from './validation';
import { PrintGroupedBill } from '../../components/print/print_bill_grouped';
interface iHasFocus {
  [key: string]: boolean;
}
let paid_type = [
  {
    label: getLanguage() === 'en' ? 'Cash' : 'بيع نقدي',
    value: 'Cash',
  },
  {
    label: getLanguage() === 'en' ? 'Debt' : 'بيع اّجل',
    value: 'Debt',
  },
];
const CreateBills = () => {
  const [cookie] = useCookies();
  const { alertError500 } = useNotification();
  const [succeed, setSucceed] = useState(false);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [hasFocus, setHasFocus] = useState<iHasFocus>({});
  const [printBill, setPrintBill] = useState({ open: false, data: {} });
  const [printBillGrouped, setPrintBillGrouped] = useState({ open: false, data:'' });

  const [isDirty, setIsDirty] = useState(false);
  const navigate = useNavigate();
  const hasInitialValues = useRef<boolean>(false);
  const t = useTranslation();


const api = useAPI()
  const converter = new NumberToString();
  const { order_id, order_no, bill_id } = useParams();
  type ExtraFields = {is_tax_bill_issued:number,bill_date:any
    ,item_count:number,tax_percent:string}
  const formik = useFormik<Partial<bill>& ExtraFields>({
    initialValues: {
      note: '',
      type: undefined,
      is_tax_bill_issued: 0,
      discount_amount: 0,
      discount_value: 0,
      tax_amount: 0,
      net_after_tax: 0,
      net_after_tax_str: 'Ninty two',
      paid: 0,
      remains: 0,
      seller_name: '',
      bill_date: {
        date: '',
        timezone_type: 0,
        timezone: '',
      },
      total_net: 0,
      total: 0,
      delivery_order: '0',
      order_id: 0,
      client_id: -1,
      piece_count: 0,
      item_count: 0,
      billdetail: [
        {
          piece_code: '',
          count: '',
          area: 0,
          price: '',
          total: 0,
          measures: '',
          description: '',
        },
      ],
     
      bill_no: '0',
    
 
      tax_percent: cookie?.company_info?.tax_percent??'0',
      order_no: '',
      date: '',
   
      client: {
        name: '',
       
        account_no: '',
        phone: '',

        address_1: '',
        address_2: undefined,
        address_3: undefined,
        bill: [],
        city: '',
        country: '',
        debt_ceiling: 44,
        department_number: undefined,
        email: '',
        fax: undefined,
        government: '',
        id: -1,
        mobile: '',

       

        postal_code: undefined,
        serial_no: '',

        type: undefined,
      
        website: '',
      },
      discount_percentage: 0,
      items_count: 0,
      code:0
     
    },
    validationSchema:BillValidation,
    onSubmit: () => {},
  });
  const fetchClient = (id: number) => {
    api
      .clients()
      .show({ id })
      .then((res: any) => {
        if (res.data.data) {
          formik.setFieldValue('client_name', res.data.data.name);
        }
      })
      .catch((err: any) => console.log(err));
  };
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    let focus = { ...hasFocus };
    focus[e.target.name] = true;
    setHasFocus(focus);
  };
  const customHandleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (Object.keys(hasFocus).includes(e.target.name)) {
      let focus = { ...hasFocus };
      focus[e.target.name] = false;
      setHasFocus(focus);
    }
    formik.handleBlur(e);
  };
 

  
  const updateBill = () => {
    if (bill_id) {
      setSending(true);
      api
        .bills()
        .update({
          bill_no: formik.values.bill_no?.toString()??'',
          billdetails: formik.values.billdetail?.map((ele: any) => ({
            ...ele,
            count: ele.piece_count,
          }))??[],
          client_id: formik.values.client?.id??-1,
          date: convertDate(formik.values.date??''),
          delivery_order: formik.values.delivery_order??'',
          discount_amount: formik.values.discount_amount??0,
          discount_percentage: formik.values.discount_percentage
            ? formik.values.discount_percentage
            : 0,
          discount_value: formik.values.discount_value??0,
          id: parseInt(bill_id),
          items_count: formik.values.items_count??0,
          net_after_tax: parseInt(formik.values.net_after_tax as any),
          net_after_tax_str: formik.values.net_after_tax_str??'',
          note: Boolean(formik.values.note) ?formik.values.note : '__',
          order_id: formik.values.order_id??-1,
          paid: formik.values.paid??0,
          piece_count: formik.values.piece_count??0,
          remains: formik.values.remains??0,
          seller_name: formik.values.seller_name??'',
          tax_amount: formik.values.tax_amount??0,
          total: formik.values.total??0,
          total_net: formik.values.total_net??0,
          type: formik.values.type ??'Cash',
        })
        .then((res: any) => {
          setSending(false);
          setSucceed(true);
        })
        .catch((err: any) => {
          setSending(false);
          alertError500(err);

          setFailed(true);
        });
    }
  };

  const fetchBill = ()=> {
if (order_id) {
      api
        .bills()
        .create({ order_id: parseInt(order_id) })
        .then((res: any) => {
          setLoading(false);
          if (res.data.data) {
            let tax_percent = res.data.data.tax_percent
              ? res.data.data.tax_percent
              : 15;
            let bill_no = res.data.data.bill_no ? res.data.data.bill_no : 0;
            formik.resetForm({
              values: {
                ...res.data.data,
                tax_percent,
                bill_no,
                order_no,
                seller_name: cookie?.company_info?.name,
                net_after_tax_str: 'Ninty nine',
              },
            });
            hasInitialValues.current = true;
            if (res.data.data.client_id) fetchClient(res.data.data.client_id);
          } else {
            setFailed(true);
          }
        })
        .catch((err: any) => {
          setLoading(false);
          setFailed(true);
        });
    }
    if (bill_id) {
      api
        .bills()
        .show({ id: parseInt(bill_id) })
        .then((res) => {
          setLoading(false);
          if (res.data.data) {
            let bill = res.data.data
            let tax_percent = cookie?.company_info?.tax_percent?
            cookie?.company_info?.tax_percent:
            15
              ;
            let bill_no = bill.bill_no ? bill.bill_no : 0;
            formik.resetForm({
              values: {
                ...res.data.data,
                tax_percent,
                bill_no:bill_no.toString()??'0',
                order_no,
                seller_name: cookie?.company_info?.name,
                remains:parseInt(String(bill.net_after_tax ?? 0)),
                net_after_tax:parseInt(String(bill.net_after_tax ?? 0)),
                paid:0 ,
                net_after_tax_str:bill.net_after_tax_str?bill.net_after_tax_str:bill.net_after_tax?
                 converter.NumToStr(parseInt(String(bill.net_after_tax ?? 0))):'',
                 is_tax_bill_issued:1,
                 bill_date:bill.date,
                 code:bill.order_statusescode ,
                 item_count:bill.items_count??0
                
              },
            });
            hasInitialValues.current = true;
          }
        })
        .catch((err: any) => {
          alertError500(err);
          setLoading(false);
          //console.log(err);
        });
    }

  }

  useEffect(() => {
    setLoading(true);
    fetchBill()
  }, []);

  const calculate_discount_value = (discount_amount:string
                                   ,discount_percentage?:number
                                   ,total?:number)=> {
    
      let discount_value = discount_percentage?
      parseFloat(discount_amount) + (((total??0)*
            parseFloat(discount_percentage.toString())) / 100 )
            : parseFloat(discount_amount)

  return      parseFloat(discount_value.toFixed(2)   )  
  }

  const calculate_total_net = (total_value?:string,discount_value?:number) => {
     let total_net = discount_value
        ? parseFloat(total_value??'0') -
          discount_value
        : parseFloat(total_value??'0');
     
        return total_net
  }

  const calculate_tax_amount = (tax_percent?:string,total_net?:number)=>{
     let tax_amount =
        (total_net??0) *
          parseFloat(tax_percent??'0') /
        100;

        return parseFloat(tax_amount.toFixed(2))
  }

  const calculate_net_after_tax = (tax_amount?:string,total_net?:number)=>{
     let net_after_tax =
        (total_net??0) +
        parseFloat(tax_amount??'0');

        return parseFloat(net_after_tax.toFixed(2))
  }

   const customHandleChange = (e: React.ChangeEvent<any>) => {
    if (bill_id && !isDirty) setIsDirty(true);
    let input_name = e.target.name ; 
    let input_value = e.target.value; 

    let new_values:Partial<bill>& ExtraFields = {...formik.values}
    if (input_name.startsWith('discount_amount') ) {

      let discount_value = calculate_discount_value(input_value,formik.values.discount_percentage,formik.values.total)
      let total_net = calculate_total_net(formik.values.total?.toString(),discount_value)
      let tax_amount = calculate_tax_amount(formik.values.tax_percent,total_net)
      let net_after_tax = calculate_net_after_tax(tax_amount?.toString(),total_net)
        new_values['discount_value']= discount_value
        new_values['total_net']=total_net
        new_values['net_after_tax']=net_after_tax
        new_values['tax_amount']=tax_amount
        
    }
     if (input_name.startsWith('discount_percentage') ) {

      let discount_value = calculate_discount_value(formik.values.discount_amount?.toString()??''
      ,parseFloat(input_value),formik.values.total)
      let total_net = calculate_total_net(formik.values.total?.toString(),discount_value)
      let tax_amount = calculate_tax_amount(formik.values.tax_percent,total_net)
      let net_after_tax = calculate_net_after_tax(tax_amount?.toString(),total_net)
        new_values['discount_value']= discount_value
        new_values['total_net']=total_net
        new_values['net_after_tax']=net_after_tax
        new_values['tax_amount']=tax_amount

        
    }

    if (input_name.startsWith('discount_value') ) {

     
      let total_net = calculate_total_net(formik.values.total?.toString(),input_value)
      let tax_amount = calculate_tax_amount(formik.values.tax_percent,total_net)
      let net_after_tax = calculate_net_after_tax(tax_amount?.toString(),total_net)
        
        new_values['total_net']=total_net
        new_values['net_after_tax']=net_after_tax
        new_values['tax_amount']=tax_amount
        
    }
    else if (input_name.startsWith ('total')) {
      let discount_value = calculate_discount_value(formik.values.discount_value?.toString()??''
                                                    ,formik.values.discount_percentage,input_value)
      let total_net = calculate_total_net(input_value?.toString(),discount_value)
      let tax_amount = calculate_tax_amount(formik.values.tax_percent,total_net)
      let net_after_tax = calculate_net_after_tax(tax_amount?.toString(),total_net)
        new_values['discount_value']= discount_value
        new_values['total_net']=total_net
        new_values['net_after_tax']=net_after_tax
        new_values['tax_amount']=tax_amount
        new_values['total_net']=total_net
    }
    else if (input_name.startsWith ( 'tax_percent')) {
        let tax_amount = calculate_tax_amount(input_value,formik.values.total_net)
         let net_after_tax = calculate_net_after_tax(tax_amount?.toString(),formik.values.total_net)
        new_values['tax_amount']=tax_amount
         new_values['net_after_tax']=net_after_tax
    }
    else if (input_name.startsWith ('tax_amount')) {
       
         let net_after_tax = calculate_net_after_tax(input_value,formik.values.total_net)
         new_values['net_after_tax']=net_after_tax
    }

    else if (input_name.startsWith('paid')){
     
      let remains = (formik.values.net_after_tax??0) - parseInt(input_value??'0')
      new_values['remains']=remains
    }
    
    type InputName = keyof bill
    new_values[input_name as InputName]= input_value
    
    formik.setValues(new_values)

  };

  
  let items =  formik.values.billdetail?.map((ele,index)=>({...ele,count:(ele.piece_count??0)*(ele.area??0)}));

  console.log(formik.values)
  //console.log('errors',formik.errors)
  if (loading) {
    return (
      <Grid container justifyContent={'center'}>
        <EllipsisLoader />
      </Grid>
    );
  }
  return (
    <Grid container rowGap={2} justifyContent="center" py={4}>
      <MySuccessMark succeed={succeed} setSucceed={setSucceed} />
      <ErrorMark failed={failed} setFailed={setFailed} />

      <Grid
        
        container
        size={12}
        rowGap={2}
        columnGap={{lg:1}}
        justifyContent={{lg:"center",sm:'space-evenly'}}>
        <Grid  container size={12} justifyContent="center"></Grid>
       
        <Title title={t("bill_details")}  backbutton_path='/bills'/>
        <Grid  container size={12} justifyContent={'center'}>
       

          {bill_id && (<>
            <Grid
              
              size={2}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}>
              <IconButton
                disabled={!havePermission('Print Bill') || (formik.values.code??0) <4}
                doTitle={t('print_bill')}
                doFunction={() => {
           
                  setPrintBill((pre) => ({
                    ...pre,
                    open: true,
                    data: bill_id,
                  }));
                  return true;
                }}
                DoIcon={<Print sx={{ color: 'var(--primary-color)' }} />}
                value={false}
                cancelTitle={t('print_bill')}
              />
            </Grid>
             <Grid
              
              size={2}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}>
              <IconButton
                disabled={!havePermission('Print Bill') || (formik.values.code??0) <4}
                doTitle={t('print_bill_grouped')}
                doFunction={() => {
                  
                  setPrintBillGrouped((pre) => ({
                    ...pre,
                    open: true,
                    data: bill_id,
                  }));
                  return true;
                }}
                DoIcon={<PrintTwoTone sx={{ color: 'var(--primary-color)' }} />}
                value={false}
                cancelTitle={t('print_bill')}
              />
            </Grid>
          </>)}
          <Grid size={2} display={'flex'} justifyContent={'center'}>
            <IconButton
              DoIcon={<Launch sx={{ color: 'var(--primary-color)' }} />}
              cancelTitle=""
              doTitle={t('show_order')}
              value={false}
              style={{ margin: '0 5px' }}
              doFunction={() => {
                {
                  navigate(`/orders/${formik.values.order_id}`);
                  return true;
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid size={12}>
          <div
            style={{ width: '100%', height: '1px', background: 'lightgray' }}
          />
        </Grid>

        <Grid  size ={{lg:3,sm:5,xs:12}}>
          <InputField
            name={order_id ? 'bill_date[date]' : 'date'}
            label={getLanguage() === 'en' ? 'Date' : 'تاريخ'}
            value={
              order_id
                ? formik.values.bill_date && formik.values.bill_date.date
                  ? new Date(formik.values.bill_date.date).toLocaleString().replaceAll('-','/')
                  : ''
                : formik.values.date?.replaceAll('-','/')
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}} >
          <InputField
            name="client.name"
            label={getLanguage() === 'en' ? 'Client' : 'العميل'}
            style={{ width: '100%' }}
            value={
               formik.values.client?.name 
            }
            disabled={true}
          />
        </Grid>

        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="bill_no"
            label={getLanguage() === 'en' ? 'View Price Number' : 'رقم عرض السعر'}
            style={{ width: '100%' }}
            value={'R'+formik.values.bill_no}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <MyRadioGroup
            name="type"
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            disabled={true}
            data={paid_type}
            title=""
            value={formik.values.type??''}
          />
        </Grid>
        {!bill_id && (
          <Grid size={{lg:3,sm:5,xs:12}}>
            <InputField
              name="order_no"
              label={getLanguage() === 'en' ? 'Order Number' : 'رقم الطلبية'}
              style={{ width: '100%' }}
              value={'Q'+formik.values.order_no}
              disabled={true}
            />
          </Grid>
        )}
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="client.account_no"
            label={getLanguage() === 'en' ? ' Account Number' : 'رقم الحساب'}
            style={{ width: '100%' }}
            value={
               formik.values.client?.account_no
            }
            disabled={true}
          />
        </Grid>

        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="tax_percent"
            label={getLanguage() === 'en' ? 'Tax Percent' : 'نسبة الضريبة'}
            style={{ width: '100%' }}
            disabled={true}
            value={formik.values.tax_percent}
            prefix={'%'}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="tax_amount"
            label={getLanguage() === 'en' ? 'Tax Ammount' : 'قيمة الضريبة'}
            value={formik.values.tax_amount}
            error={
              Boolean(formik.errors.tax_amount) &&
              formik.touched.tax_amount &&
              formik.errors.tax_amount
            }
            style={{ width: '100%' }}
            disabled={true}
            onBlur={customHandleBlur}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="remains"
            label={getLanguage() === 'en' ? 'Remain' : 'المبلغ الباقي'}
            value={formik.values.remains}
            error={
              Boolean(formik.errors.remains) &&
              formik.touched.remains &&
              formik.errors.remains
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>

        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="discount_amount"
            label={getLanguage() === 'en' ? 'Discount Amount' : 'كمية الخصم'}
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            value={formik.values.discount_amount}
            error={
              Boolean(formik.errors.discount_amount) &&
              formik.touched.discount_amount &&
              formik.errors.discount_amount
            }
            style={{ width: '100%' }}
            onBlur={customHandleBlur}
            disabled={(formik.values.code??0) > 5}
            onFocus={handleFocus}
          />
        </Grid>
       
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="discount_percentage"
            label={getLanguage() === 'en' ? 'Discount Percent' : 'نسبة الخصم'}
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            value={
               formik.values.discount_percentage
            }
            prefix={'%'}
            onBlur={customHandleBlur}
            error={
              Boolean(formik.errors.discount_percentage) &&
              formik.touched.discount_percentage &&
              formik.errors.discount_percentage
            }
            style={{ width: '100%' }}
            disabled={(formik.values.code??0) > 5}
            onFocus={handleFocus}
          />
        </Grid>
         <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="discount_value"
            label={getLanguage() === 'en' ? 'Discount Value' : 'مبلغ الخصم'}
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            value={formik.values.discount_value}
            error={
              Boolean(formik.errors.discount_value) &&
            
              formik.errors.discount_value
            }
            style={{ width: '100%' }}
            onBlur={customHandleBlur}
            disabled={(formik.values.code??0) > 5}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="paid"
            label={getLanguage() === 'en' ? 'Paid' : 'المبلغ المدفوع'}
            value={formik.values.paid}
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            error={
              Boolean(formik.errors.paid) &&
              formik.touched.paid &&
              formik.errors.paid
            }
            onBlur={customHandleBlur}
            style={{ width: '100%' }}
            disabled={(formik.values.code??0) > 5 || formik.values.type !=='Cash'}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="total"
            label={getLanguage() === 'en' ? 'Totall' : 'اجمالي'}
            value={formik.values.total}
            onChange={
              havePermission('Edit Bill') ? customHandleChange : () => {}
            }
            error={
              Boolean(formik.errors.total) &&
              formik.touched.total &&
              formik.errors.total
            }
            onBlur={customHandleBlur}
            style={{ width: '100%' }}
            disabled={(formik.values.code??0) > 5}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="total_net"
            label={getLanguage() === 'en' ? 'Totall Net Worth' : 'الصافي'}
            value={formik.values.total_net}
            onBlur={customHandleBlur}
            error={
              Boolean(formik.errors.total_net) &&
              formik.touched.total_net &&
              formik.errors.total_net
            }
            style={{ width: '100%' }}
            disabled={true}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="net_after_tax"
            label={
              getLanguage() === 'en'
                ? 'Net Worth After Tax'
                : 'الصافي بعد الضريبة'
            }
            value={formik.values.net_after_tax}
            onBlur={customHandleBlur}
            error={
              Boolean(formik.errors.net_after_tax) &&
              formik.touched.net_after_tax &&
              formik.errors.net_after_tax
            }
            style={{ width: '100%' }}
            disabled={true}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="net_after_tax_str"
            label={getLanguage() === 'en' ? 'Net Worth' : 'المبلغ كتابة'}
            value={converter.NumToStr(formik.values.net_after_tax??'')}
            error={
              Boolean(formik.errors.net_after_tax_str) &&
              formik.touched.net_after_tax_str &&
              formik.errors.net_after_tax_str
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="seller_name"
            label={getLanguage() === 'en' ? 'Seller Name' : 'اسم البائع'}
            value={formik.values.seller_name}
            error={
              Boolean(formik.errors.seller_name) &&
              formik.touched.seller_name &&
              formik.errors.seller_name
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="item_count"
            label={
              getLanguage() === 'en'
                ? "Bill's Items Count"
                : ' عدد بنود الفاتورة'
            }
            value={
              order_id ? formik.values.item_count : formik.values.items_count
            }
            error={
              Boolean(formik.errors.item_count) &&
              formik.touched.item_count &&
              formik.errors.item_count
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <InputField
            name="piece_count"
            label={getLanguage() === 'en' ? 'Piece Count ' : 'عدد القطع'}
            value={formik.values.piece_count}
            error={
              Boolean(formik.errors.piece_count) &&
              formik.touched.piece_count &&
              formik.errors.piece_count
            }
            style={{ width: '100%' }}
            disabled={true}
          />
        </Grid>
        <Grid size={{lg:3,sm:5,xs:12}}>
          <NumberField
            name="client.phone"
            label={getLanguage() === 'en' ? 'Phone' : 'جوال'}
            style={{ width: '100%' }}
            disabled={true}
            value={bill_id ? formik.values.client?.phone : ''}
          />
        </Grid>

        <Grid size={{lg:3,sm:5,xs:12}}>
          <Textarea
            label={getLanguage() === 'en' ? 'Note' : 'ملاحظة'}
            value={formik.values.note}
            onChange={customHandleChange}
            name="note"
            style={{ width: '100%' }}
            error={
              Boolean(formik.errors.note) &&
              formik.touched.note &&
              formik.errors.note
            }
            disabled={(formik.values.code ??0) > 5}
          />
        </Grid>
      </Grid>
      <Grid  container size={12}>
        <Table>
          <TableHead>
            <TableCell>
              {getLanguage() === 'en' ? 'Totall' : 'اجمالي'}
            </TableCell>
            <TableCell>{getLanguage() === 'en' ? 'Price' : 'السعر'}</TableCell>
            <TableCell>{t('area')+`(${t('m')}²)`}</TableCell>
            <TableCell>{t('piece_count')}</TableCell>
            <TableCell>
              {getLanguage() === 'en' ? 'Ammount' : 'الكمية'}
            </TableCell>
            <TableCell>
              {getLanguage() === 'en' ? 'Measures' : 'مقاسات'}
            </TableCell>
            <TableCell>
              {getLanguage() === 'en' ? 'Desciption' : 'البيان'}
            </TableCell>
            <TableCell>
              {getLanguage() === 'en' ? 'Piece Code' : 'رقم القطعة'}
            </TableCell>
          </TableHead>
          <TableBody>
            {items
              ? items.map((ele, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['total']}
                    </TableCell>
                    <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['price']}
                    </TableCell>
                   
                     <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['area']}
                    </TableCell>
                     <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['piece_count']}
                    </TableCell>
                    <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['count']}
                    </TableCell>
                    <TableCell style={{ borderLeft: '1px dashed gray' ,direction:'ltr'}}>
                      {ele['measures']}
                    </TableCell>
                    <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['description']}
                    </TableCell>
                    <TableCell style={{ borderLeft: '1px dashed gray' }}>
                      {ele['piece_code']}
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </Grid>
      <Grid  container size={9} justifyContent="center" py={2}>
        {!Boolean(order_id) ? (
          <Grid
            
            container
            size={3}
            alignItems="end"
            mx={1}
            display={'flex'}
            justifyContent={'center'}>
            <GreenButton
              fullWidth={true}
              fun={() => updateBill()}
              label={getLanguage() === 'en' ? 'Save' : 'حفظ'}
              loading={sending}
              disabled={!isDirty || (formik.values.code ??0) > 5}>
              <Save sx={{ color: 'white' }} />
            </GreenButton>
          </Grid>
        ) : null}
      
{false &&
        <Grid
          
          container
          size={3}
          alignItems="end"
          mx={1}
          display={'flex'}
          justifyContent={'center'}>
          <WhiteButton
            fullWidth={true}
            fun={() => {
              navigate('/bills');
            }}
            label={t('cancel')}>
            <Cancel sx={{ color: 'red' }} />
          </WhiteButton>
        </Grid>}
      
      </Grid>
      {printBill.open && (
        <PrintBill
          close={() => setPrintBill((pre) => ({ ...pre, open: false }))}
          data={printBill.data}
      
        />
      )}
     {printBillGrouped.open &&
        <PrintGroupedBill 
         close={() => setPrintBillGrouped((pre) => ({ ...pre, open: false }))}
          data={printBillGrouped.data}
        />
      }
    </Grid>
  );
};
export default CreateBills;
